module.exports = __webpack_public_path__ + "static/media/Exlamation-icon-no-padding.982fa873.png";